<template>
  <div>
    <div class="left-panel">
      <div class="heading">
        <span class="cons-name">{{ consumerData.firstName + ' ' + consumerData.lastName }}</span>
        <a class="stripe-link" :href="consumerData.customerURL" target="_blank" v-if="consumerData.customerURL !== null"><i class="fa fa-link"></i></a>
        <div class="switch-call">
          <div class="switch">
            <div :class="{'slider':true, 'active':isActive, 'disabled':showActiveModal}"
              @click="showActiveModal = true"></div>
            <span class="label" v-show="isActive">ACTIVE</span>
            <span class="label" v-show="!isActive">DEACTIVATED</span>
          </div>
          <div class="button cta success call small" @click="call(consumerData)">
            <i class="fa fa-phone"></i>{{ $t('consumer.call') }}
          </div>
        </div>
      </div>

      <div class="body">
        <account-details :referralLoading="referralLoading"
          ref="accountDetails"></account-details>
      </div>

      <div class="fix-buttons">
        <a :class="{'button cta small success block':true, 'disabled':formHasError}"
          @click="triggerSave">
          <span v-show="!formLoading">{{ $t('consumer.save') }}</span>
          <span v-show="formLoading">
            <i class="fa fa-spinner fa-spin fa-fw"></i>
            {{ $t('consumer.saving') }}
          </span>
        </a>

      </div>
    </div>
    <div class="toggle-mobile" @click="showRecords = !showRecords">
      <span v-if="!showRecords">Show Records <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Records <i class="fa fa-chevron-down"></i></span>  
    </div>
    <div :class="['right-panel', showRecords ? 'mobile-right-panel' : '']" @scroll="onScroll">
      <ul class="tab">
        <li :class="{'active':activeTab === 0}" @click="switchTab(0)">
          {{ $t('consumer.tabLabel.referrals') }}
        </li>
        <li :class="{'active':activeTab === 1}" @click="switchTab(1)">
          {{ $t('consumer.tabLabel.transactions') }}
        </li>
        <li :class="{'active':activeTab === 2}" @click="switchTab(2)">
          {{ $t('consumer.tabLabel.reservations') }}
        </li>
        <li :class="{'active':activeTab === 3}" @click="switchTab(3)">
          {{ $t('consumer.tabLabel.ratings') }}
        </li>
        <li :class="{'active':activeTab === 4}" @click="switchTab(4)">
          {{ $t('consumer.tabLabel.creditCard') }}
        </li>
        <li :class="{'active':activeTab === 5}" @click="switchTab(5)">
          {{ $t('consumer.tabLabel.promoCodes') }}
        </li>
      </ul>

      <div class="tab-contents">
        <div :class="{'tab-content':true, 'active':activeTab == 0}">
          <referrals :isMobile="isMobile" :conId="$route.params.id" ref="referrals"></referrals>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab == 1}">
          <transactions :isMobile="isMobile" :conId="$route.params.id" ref="transactions"></transactions>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab == 2}">
          <reservations :isMobile="isMobile" :conId="$route.params.id" ref="reservations"></reservations>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab == 3}">
          <ratings :isMobile="isMobile" :conId="$route.params.id" ref="ratings"></ratings>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab == 4}">
          <creditCards :isMobile="isMobile" :conId="$route.params.id" ref="creditCards"></creditCards>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab == 5}">
          <promoCodes :isMobile="isMobile" :conId="$route.params.id" ref="promoCodes"></promoCodes>
        </div>
      </div>
    </div>

    <loading-modal :showModal="loading" :modalMessage="$t('consumer.loading')"></loading-modal>

    <div :class="{'modal':true, 'show':formResult.isDone}">
      <div class="bg-overlay" @click="closeFormResult"></div>
      <div class="modal-content formResult">
        <p>{{ formResult.message }}</p>

        <a class="button cta warning block small" @click="closeFormResult">
          {{ $t('provider.close') }}
        </a>
      </div>
    </div>

    <div :class="{'modal':true, 'show':showActiveModal}">
      <div class="modal-content active-confirmation">
        <p v-show="!isActive">
          Are you sure you want to activate
          <b>{{ consumerData.firstName + ' ' + consumerData.lastName }}</b>?
        </p>
        <p v-show="isActive">
          Are you sure you want to deactivate
          <b>{{ consumerData.firstName + ' ' + consumerData.lastName }}</b>?
        </p>
        </p>
        <div class="button cta warning" @click="showActiveModal = false">No</div>
        <div class="button cta success" @click="toggleConsActive">
          <span v-show="!statusLoading">Yes</span>
          <i class="fa fa-spinner fa-spin" v-show="statusLoading"></i>
        </div>
      </div>
    </div>

   <div class="logs">
      <div class="trigger">
        <a :class="{'logs-toggle':true, on:showLogs}" @click="toggleLogs"><i :class="logsIcon"></i></a>
      </div>
      <div :class="{'logs-panel':true, hide:!showLogs}">
        <div class="heading">
          Logs
          <select v-model="logDate" :disabled="logsLoading" :class="{'disabled':logsLoading}">
            <option value="all">All</option>
            <option value="custom">Custom</option>
          </select>
        </div>
        <logs ref="logs"></logs>
      </div>
    </div>

    <countrySelectModal></countrySelectModal>
  </div>
</template>

<script>
import accountDetails from './AccountDetails'
import referrals from './Referrals'
import transactions from './Transactions'
import reservations from './Reservations'
import ratings from './Ratings'
import creditCards from './CreditCards'
import promoCodes from './PromoCodes'
import logs from './Logs'
import countrySelectModal from './CountrySelectModal'
import loadingModal from '../Partials/LoadingModal'
import ApiConsumer from '@/modules/api/consumer/user-info'
import ApiReferrals from '@/modules/api/consumer/referrals'
import ApiProvider from '@/modules/api/provider/user-info'

export default {
  name: 'consumer',
  components: {
    accountDetails, referrals, transactions, reservations,
    ratings, creditCards, promoCodes, loadingModal, countrySelectModal, logs
  },
  data () {
    return {
      activeTab: 0,
      loading: false,
      referralLoading: false,
      showActiveModal: false,
      statusLoading: false,
      showLogs: false,
      logDate: 'all',
      showRecords: false,
      isMobile: false
    }
  },
  computed: {
    conId () { return this.$route.params.id },
    consumerData () {
      let userInfo = this.$store.state.consumer.userInfo
      if (JSON.stringify(userInfo) === '{}') {
        return { firstName: '', lastName: '', mobile: ''}
      }

      return {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        mobile: userInfo.mobile,
        customerURL: userInfo.customerURL
      }
    },
    isActive () { return this.$store.state.consumer.userInfo.enabled },
    formHasError () { return this.$store.state.consumer.formHasError },
    formLoading () { return this.$store.state.consumer.formLoading },
    formResult () { return this.$store.state.consumer.formSave },
    logsIcon () { return !this.showLogs ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x'},
    logsLoading () { return this.$store.state.consumer.logs.loading }
  },
  methods: {
    init () {
      this.setScreenSize()
      this.getConsumerData()
      this.getTotalReferrals()
    },
    getConsumerData () {
      let self = this
      self.$store.commit('consumer/resetUserInfo')

      self.loading = true
      ApiConsumer.getConsumerData(self, self.$route.params.id, function (res) {
        self.loading = false
      })
    },
    getTotalReferrals () {
      let self = this
      self.$store.commit('consumer/resetTotalReferrals')
      self.referralLoading = true
      ApiReferrals.getTotalReferrals(self, self.$route.params.id, function () {
        self.referralLoading = false
      })
    },
    switchTab (index) {
      this.activeTab = index
    },
    onScroll (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        if (this.activeTab === 0 && this.$refs.referrals.getReferrals()) {
          this.$refs.referrals.getReferrals()
        }
        // if (this.activeTab === 1 && this.$refs.transactions.getTransactions()) {
        //   this.$refs.transactions.getTransactions()
        // }
        if (this.activeTab === 2 && this.$refs.reservations.getTransactions()) {
          this.$refs.reservations.getTransactions()
        }
        if (this.activeTab === 3 && this.$refs.ratings.getRatings()) {
          this.$refs.ratings.getRatings()
        }
        if (this.activeTab === 4 && this.$refs.creditCards.getCards()) {
          this.$refs.creditCards.getCards()
        }
        if (this.activeTab === 5 && this.$refs.promoCodes.getPromoCodes()) {
          this.$refs.promoCodes.getPromoCodes()
        }

      }
    },
    call (user) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    triggerSave () {
      if (this.$refs.accountDetails.save()) {
        this.$refs.accountDetails.save()
      }
    },
    closeFormResult () {
      this.$store.commit('consumer/setFormSavingDone', false)
      this.$store.commit('consumer/setFormSaveMessage', '')
    },
    toggleConsActive () {
      let self = this
      self.statusLoading = true

      // Using same end point with provider activate/deactivate - since both uses Contacts table
      ApiProvider.updateProviderStatus(self, {
        id: self.$route.params.id,
        isActive: !this.isActive
      }, function (res) {
        self.statusLoading = false
        self.showActiveModal = false
        self.$store.commit('consumer/setuserActive', !self.isActive)
      })

      // setTimeout(() => {
      //   self.statusLoading = false
      //   self.showActiveModal = false
      //   self.$store.commit('consumer/setuserActive', !self.isActive)
      // }, 2000)
    },
    toggleLogs () { this.showLogs = !this.showLogs },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  watch: {
    conId: function (value) {
      this.init()
      this.showLogs = false
      this.logDate = 'all'
    },
    logDate: function (value) {
      if (this.$refs.logs.dateToggle(value)) {
        this.$refs.logs.dateToggle(value)
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
$fix-button-height: 60px;

.heading{
  height: 50px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 10px 0;

  .switch-call {
    display: inline;
  }

  & .cons-name{
    padding: 0 5px 0 15px;
  }

  & .stripe-link {
    display: inline-block;
    margin-right: 20px;
  }

   select{
    width: auto;
    float: right;
    font-size: 16px;
    margin-top: 5px;
    margin-right: 40px;
  }
}

.call{
  float: right;
  margin-right: 10px;
  text-transform: uppercase;
  .fa{
    margin-right: 5px;
  }
}

.body{ padding: 20px; }

.switch{
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-top: 2px;

  .slider{
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;

    &.disabled{ opacity: .4; }
    &:before{
      content: '';
      position: absolute;
      top: 2px;
      left: 3px;
      width: 21px;
      height: 21px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 25px; }
    }
  }
  .label{
    display: inline-block;
    vertical-align: 8px;
    margin-left: 5px;
    font-size: 14px;
    color: #555;
    text-transform: uppercase;
  }
}

.call{
  float: right;
  margin-right: 10px;
  text-transform: uppercase;
  .fa{
    margin-right: 5px;
  }
}

.left-panel{
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 30%;
  height: 100%;
  box-shadow: 2px 0 4px rgba(0,0,0,0.2);
  background-color: #F4F8F9;
  overflow-y: auto;
  padding-bottom: $fix-button-height;

  .heading{
    padding-left: 50px;
  }
}

.right-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: 70%;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #d5d5d5;
  overflow-y: auto;

  .heading{
    font-size:24px;
    padding: 10px 20px;
  }

  .tab{
    background: #d5d5d5;
    & .active{ background: #ededed; }
  }
  .tab-contents{ background: #ededed; }
}

.tab{
  list-style: none;
  padding: 0;
  margin: 15px 0 0;
  display: flex;
  position: relative;
  z-index: 2;

  li{
    color: #0D79F2;
    padding: 15px 25px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    cursor: pointer;

    &.grow{
      flex-grow: 100;
    }
    &.active{
      background: #fff;
      box-shadow: 0 -1px 2px rgba(0,0,0, .1);
      border-radius: 2px 2px 0 0;
      color: #777;
    }
  }
}

.tab-contents{
  background: #fff;
  z-index: 1;
  position: relative;
  box-shadow: 0 0 2px 1px rgba(0,0,0, .1);

  .tab-content{
    padding: 20px;
    display: none;

    &.no-H-padding{ padding: 20px 0; }
    &.active{
      display: block;
    }
  }
}

.fix-buttons{
  position: fixed;
  z-index: 3;
  bottom: 0;
  left: 0;
  padding: 10px;
  width: 30%;
  height: $fix-button-height;
  background: #eee;
  box-sizing: border-box;
  display: flex;

  a{
    margin: 0 10px 0 auto;

    &.right{ margin-left: auto; }
  }
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .modal-content{
    position: absolute;
    top: 45%;
    left: 50%;
    width: 400px;
    padding: 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    margin-left: -200px;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

  }
  &.show{
    display: block;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
}

$toggle-size: 50px;
.logs-toggle {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3;
  width: $toggle-size;
  height: $toggle-size;
  line-height: $toggle-size;
  text-align: center;
  color: #777;
  transition: all 250ms;
  border-radius: 0;
  background-color: #F25E0D;
  color: #fff;
  border-bottom-left-radius: 3px;
  box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  cursor: pointer;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease;
  -moz-transition: .5s ease;
  -o-transition: .5s ease;
  transition: .5s ease;

  i { line-height: inherit; }

  &.on{
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
    -webkit-transition: .5s ease;
    -moz-transition: .5s ease;
    -o-transition: .5s ease;
    transition: .5s ease;
  }
}
$right-panel-width: 400px;
.logs-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: $right-panel-width;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #f4f8f9;
  transition: all .6s ease;

  &.hide{
    right: -#{$right-panel-width};
    box-shadow: -2px 0 8px rgba(0,0,0,0.0);
  }
  .heading{
    font-size:24px;
    padding: 10px 20px;
    margin-bottom: 7px;
  }
}

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}

.toggle-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .left-panel {
    width: 100%;
    .heading {
      .switch-call {
        display: flex;
        justify-content: space-between;
      }
      .switch {
        margin-top: 3px;
        margin-left: 15px;
      }

      .call {
        margin-right: 30%;
      }
    }

    .body {
      margin-top: 12px;
      padding-bottom: 100px;
    }

    .fix-buttons {
      width: 100%;

      .button {
        width: 50%;
        margin: 0 auto;
      }
    }
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }

  .right-panel {
    width: 100%;
    z-index: 1;
    top: 100%;
    transition: all 0.3s ease;

    &.mobile-right-panel {
      top: 0;
      z-index: 2;

      .tab {
        margin-top: 70px;
        display: flex;
        overflow-x: scroll;

        li {
          font-size: 13px;
        }
      }

      .tab-contents {
        width: 100%;
        .tab-content {
          padding-bottom: 100px;

          &.history-panel {
            padding: 0;
            padding-top: 20px;
            padding-bottom: 60px;
          }

        }
        .fixed-footer {
          width: 100%;
          bottom: 45px;
          background: #fff;
          color: #000;
          border-top: 1px solid #aaa;
        }
      }
    }
  }

  .logs-toggle {
    z-index: 13;
  }

  .logs-panel {
    width: 100%;
    z-index: 12;
    &.hide {
      right: -430px;
    }
  }

  .fix-buttons {
    width: 100%;
    bottom: 45px;
    a {
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/index.vue